import { ReduxHelper } from "helpers";
import { ICreateRatingRequest } from "models/RequestModels";
export const prefix = "RATING";

const createRating = ReduxHelper.generateActions<ICreateRatingRequest>(`${prefix}/CREATE_RATING`);

export {
    createRating
};
